<template>
  <div class="addAddress">
    <div class="add">
<!--      <input clearable id="suggestId" style="z-index: 999;position: absolute;left: 150px;right: 200px;top: 220px;width: 250px;height: 20px;z-index: 999" type="text" placeholder="请输入你的地址"/>-->

      <el-form :model="info.addressInfo" :rules="rules" ref="info.addressInfo" label-width="95px" class="demo-ruleForm">
        <el-form-item
          label="姓名："
          prop="name"
        >
          <el-input v-model="info.addressInfo.name" autocomplete="off" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item
          label="电话："
          prop="mobile"
        >
          <el-input v-model="info.addressInfo.mobile" autocomplete="off" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item
          label="地址："
          prop="address"
        >
            <el-input
              id="suggestId"
              type="text"
              placeholder="省市区"
              v-model="info.addressInfo.address"
              auto-complete="off"
            ></el-input>
            <div id="allmap" class="allmap">

            </div>

        </el-form-item>
        <!--地图-->
        <el-form-item
          label="详细地址："
          prop="detaileAddress"
        >
          <el-input v-model="info.addressInfo.detaileAddress" autocomplete="off" placeholder="请输入详细地址" @input="search"/>
        </el-form-item>
        <el-form-item>
          <el-button @click="submitForm('info.addressInfo')">提交</el-button>
        </el-form-item>
      </el-form>
      <img class="icon" src="../../assets/images/courier/close.png" alt="" @click="close">
    </div>
  </div>
</template>

<script>
import AreaCity from '../../components/AreaCity'
import {reqChangeAddress, reqExpress} from '../../api'
import {init, tip} from '../../utils/map'
export default {
  props: ['data'],
  data () {
    let validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/
      if(!reg.test(value)){
        callback(new Error('手机号码不正确'))
      }else{
        callback()
      }
    }
    return {
      info:this.data,
      rules: {
        address:[{ required: true, message: '请选择地址', trigger: 'blur' }],
        name:[{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile:[{ required: true, message: '请输入电话', trigger: 'blur' },{validator: validPhone, trigger: 'blur'}],
        detaileAddress:[{ required: true, message: '请输入详细地址', trigger: 'blur' }],
      }
    }
  },
  mounted() {
    let that = this;
    this.$nextTick(() => {
      let input = document.getElementById("suggestId");
      let am = document.getElementsByClassName("allmap");

      for (let i = 0; i < am.length; i++) {

        let map = new BMap.Map(am[i].id) // 创建Map实例
        map.centerAndZoom(that.info.addressInfo.address, 15)
        map.enableScrollWheelZoom(true);
        // searchByStationName(that.info.addressInfo.address, map, localSearch);

        // init(that.info.addressInfo.address, am[i].id);
        // tip(input.id, input, am[i].id, this.info.addressInfo.address,(res,item,target)=>{
          // this.setAddress(res,item,target)
        // });
        // 添加带有定位的导航控件
        let navigationControl = new BMap.NavigationControl({
          // 启用显示定位
          enableGeolocation: true
        })
        map.addControl(navigationControl)
        function setPlace () {
          map.clearOverlays() // 清除地图上所有覆盖物
          function myFun () {
            let poi = local.getResults().getPoi(0).point // 获取第一个智能搜索的结果
            map.centerAndZoom(poi, 18)
            map.addOverlay(new BMap.Marker(new BMap.Point(poi.lng, poi.lat))) // 添加标注
          }
          let local = new BMap.LocalSearch(map, {
            onSearchComplete:myFun
          })
          local.search(that.myValue)
        }

        let ac = new BMap.Autocomplete( // 建立一个自动完成的对象
          {'input': input.id}
        )
        that.myValue = that.info.addressInfo.address + that.info.addressInfo.detaileAddress
        ac.addEventListener('onconfirm', function (e) { // 鼠标点击下拉列表后的事件
          let _value = e.item.value
          that.myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
          that.info.addressInfo.address = that.myValue;
          // this.info.addressInfo.address = myValue;
          // input.setAttribute('data-address', myValue)
          // input.blur()
          setPlace()
          // searchByStationName(myValue, map, localSearch)
          return that.myValue
        })
        that.setPlace = setPlace;
        setPlace();
        ac.setInputValue(that.info.addressInfo.address);
      }
      // document.getElementsByClassName("el-input__inner")[2].focus();
    });
  },
  methods: {
    search (e) {
      this.myValue = this.info.addressInfo.address + this.info.addressInfo.detaileAddress
      this.setPlace();
    },
    close () {
      this.$emit('handleClick')
    },
    city(city) {
      this.info.addressInfo.address = JSON.stringify(city)
    },
    // 提交信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          reqChangeAddress(this.info.addressInfo).then(res => {
            if(res.code === 200){
              if(this.data.type === 'add'){
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                })
              }
              this.$emit('handleClick')
              this.$emit('getAddress')
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  components: {
    AreaCity
  }
}
</script>

<style scoped lang="less" type="text/less">
.allmap {
  width: 100%;
  height: 250px;
  margin-bottom: 20px;
}

.addAddress{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  //z-index: 1000;
  .add{
    position: relative;
    margin:10px auto;
    padding-top:50px;
    width: 735px;
    height: 760px;
    box-sizing: border-box;
    background: #fff;
    .title{
      margin-bottom: 43px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      color: #2c2c2c;
    }
    form{
      padding:0 44px;

      button{
        display: block;
        width: 200px;
        height: 46px;
        margin:0 auto 0;
        background: #61aee6;
        border-radius: 23px;
        font-size: 16px;
        font-weight: bold;
        border:none;
        color: #ffffff;
      }
    }
    .icon{
      position: absolute;
      top: 13px;
      right: 16px;
      cursor: pointer;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Person/EditAddress.vue